import { render, staticRenderFns } from "./NewInboundTodo.vue?vue&type=template&id=4c316cad&scoped=true"
import script from "./NewInboundTodo.vue?vue&type=script&lang=js"
export * from "./NewInboundTodo.vue?vue&type=script&lang=js"
import style0 from "./NewInboundTodo.vue?vue&type=style&index=0&id=4c316cad&prod&lang=scss"
import style1 from "./NewInboundTodo.vue?vue&type=style&index=1&id=4c316cad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c316cad",
  null
  
)

export default component.exports